module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-fill-check-27b11e29.svg";